import React from 'react';
import Stockdata from '../components/Stockdata';
//import TradingViewWidget from './tradeview/TradingViewWidget';
//moved tradingview widget to stockdata.jsx


const Home = () => {
  return(
  <>
    <Stockdata />
  </>
  );
};

export default Home;
